import { HiringCopilotRequest } from 'libs/end-to-end/src/custom-viz/HiringCopilotTypes';
import { getDateAsYYYYMMDD } from 'libs/end-to-end/src/dates';
import { DateTime } from 'luxon';

/**
 * @note: this is a temp fix until we have custom filter sets for the hiring
 * copilot
 */
export const getHiringCopilotRequestDropdowns = ({
  uniqueValuesByColumn,
  numPreviousDaysOfApplicants,
  dateNow,
  filterSelections,
}: {
  uniqueValuesByColumn: { columnName: string; uniqueValues: string[] }[];
  numPreviousDaysOfApplicants: number;
  dateNow?: DateTime;
  filterSelections?: Record<string, string[]>;
}): HiringCopilotRequest['inputs']['dropdowns'] => {
  const now = dateNow ?? DateTime.now();

  const startDate = getDateAsYYYYMMDD(
    now.minus({ days: numPreviousDaysOfApplicants }).toJSDate(),
  );

  const endDate = getDateAsYYYYMMDD(now.toJSDate());

  const valuesForColumn = (columnName: string): string[] => {
    const selected = filterSelections?.[columnName];
    if (selected && selected.length > 0) return selected;
    return (
      uniqueValuesByColumn.find((item) => item.columnName === columnName)
        ?.uniqueValues ?? []
    );
  };

  return {
    department: valuesForColumn('department'),
    job_title: valuesForColumn('job_title'),
    location: valuesForColumn('location'),
    start_date: [startDate],
    end_date: [endDate],
  };
};
